import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {Modal, Upload} from "antd";
import {t} from "i18next";
import {getImagePathWithTheme, isDarkMode} from "@/utils";
import Dragger from "antd/es/upload/Dragger";
import {MAX_Z_INDEX} from "@/Const";
import global from "@/global";
import {readFileText} from "@/VideoHighlightUtils";
import {IconClose} from "@/Icon";

let mCallback:any;

const DialogImportMindmapFromMarkdown = forwardRef((props:{onClose:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
        onCloseDialog:onCloseDialog
    }))
    const [isShowDialog,setIsShowDialog] = useState(false);


    const onPaste = (event:any)=>{
        // event.preventDefault();
        // 可以通过 event.clipboardData 访问剪切板数据
        var clipboardData = event.clipboardData || window.clipboardData;
        var pastedData = clipboardData.getData('Text');
        if (mCallback){
            mCallback(pastedData);
        }
    }
    useEffect(()=>{
        document.body.addEventListener('paste',onPaste);
        return ()=>{
            document.body.removeEventListener('paste',onPaste);
        }
    })

    const onShowDialog = (callback:any)=>{
        mCallback = callback;
        setIsShowDialog(true);
        global.g_showDialogs.dialogImportMindmapFromMd = true;
    }
    const onCloseDialog = ()=>{
        mCallback = null;
        setIsShowDialog(false);
        global.g_showDialogs.dialogImportMindmapFromMd = false;
    }

    const uploadProps:{ beforeUpload: (file) => string } = {
        beforeUpload:(file)=>{
            if (mCallback){
                readFileText(file).then(res=>{
                    mCallback(res);
                })
                setIsShowDialog(false);
            }
            return Upload.LIST_IGNORE
        }
    }

    return(
        <Modal zIndex={MAX_Z_INDEX} centered={true} open={isShowDialog} closable={true} closeIcon={<IconClose/>} footer={''} afterClose={()=>{
            global.g_showDialogs.dialogImportMindmapFromMd = false;
            if (props.onClose) {
                props.onClose();
            }
        }}
               onCancel={(e) => setIsShowDialog(false)} width='625px' style={{height: 'auto'}}>
            <div className='font-size-12' style={{
                margin: '-22px',
                padding: '20px',
                height:'324px',
                flexDirection: 'column'
            }}>
                <span className='dialog-title'>{t("ImportFromMarkdown")}</span>
                {/*<div className='line' style={{margin: '12px -16px'}}></div>*/}
                <div className={isDarkMode()?'drag-dashed-border-dark':'drag-dashed-border'} style={{margin:'22px 0',height:'calc(100% - 44px)' }}>

                    <Dragger {...uploadProps}  accept={".md"} style={{outline:'none',background:'transparent',border:'none'}}>
                        <p className="ant-upload-text">
                            <img style={{width:'66px',height:'66px'}} src={getImagePathWithTheme("highlight_import")}/>
                        </p>
                        <p className={'font-family-medium'} style={{color:'var(--drag-file-desc-color)'}}>{t("DropFileHereOrClick")}</p>
                        <p className={'default-font-family'} style={{color:'var(--text-color-bab8b8)',marginTop:'6px',whiteSpace:'pre'}}>{t("ImportingAMarkdownFileOrPasting")}</p>
                    </Dragger>
                </div>
            </div>
        </Modal>
    )
})

export default DialogImportMindmapFromMarkdown;
















